import React from 'react'
import styles from '../../styles/components/assets/AssetsInformationSystems.module.scss'

export function severityToneClass(severity: string | null | undefined): string {
  const s = String(severity || 'INFO').toUpperCase()
  if (s === 'CRITICAL') return styles.severityDotCritical
  if (s === 'HIGH') return styles.severityDotHigh
  if (s === 'MEDIUM') return styles.severityDotMedium
  if (s === 'LOW') return styles.severityDotLow
  return styles.severityDotInfo
}

export function severityBadgeToneClass(severity: string | null | undefined): string {
  const s = String(severity || 'INFO').toUpperCase()
  if (s === 'CRITICAL') return styles.severityBadgeCritical
  if (s === 'HIGH') return styles.severityBadgeHigh
  if (s === 'MEDIUM') return styles.severityBadgeMedium
  return styles.severityBadgeLow
}

interface SeverityDotProps {
  severity?: string | null
  className?: string
  title?: string
}

export default function SeverityDot({ severity, className = '', title }: SeverityDotProps) {
  return (
    <span
      className={`${styles.severityDot} ${severityToneClass(severity)} ${className}`.trim()}
      aria-hidden={title ? undefined : true}
      title={title}
    />
  )
}
